<div class="row padding-bet">
  <div class="component image file-type-icon-media-link col-12 indent-top">
    <div class="component-content">
      <a href="#"><img src="{{data$ |async}}" alt="Technician with iPad" width="100%" height="100%"
          data-variantfieldname="Image" class="section-5-img"></a><span class="image-caption field-imagecaption"></span>
    </div>
  </div>
</div>